var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Atom/Icons For Side Bar"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.27221 3.00552C7.86401 3.33198 6.5688 4.02924 5.52092 5.025C4.47304 6.02075 3.71066 7.27873 3.31284 8.66845C2.91503 10.0582 2.89627 11.529 3.25852 12.9284C3.62078 14.3279 4.35084 15.6049 5.37299 16.627C6.39514 17.6492 7.67215 18.3792 9.07156 18.7415C10.471 19.1037 11.9418 19.085 13.3315 18.6872C14.7213 18.2893 15.9792 17.527 16.975 16.4791C17.9708 15.4312 18.668 14.136 18.9945 12.7278C18.9945 12.489 18.8996 12.2601 18.7308 12.0912C18.562 11.9224 18.333 11.8276 18.0943 11.8276H11.9728C11.4953 11.8276 11.0374 11.6379 10.6997 11.3003C10.3621 10.9626 10.1724 10.5047 10.1724 10.0272V3.72569C10.1612 3.61904 10.129 3.51567 10.0775 3.42157C10.0261 3.32748 9.95651 3.24453 9.87277 3.17754C9.78903 3.11055 9.69282 3.06085 9.58973 3.03132C9.48664 3.00179 9.37871 2.99302 9.27221 3.00552Z",
    stroke: "#435869",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7732 3.27545C14.9162 3.67792 15.9544 4.33167 16.8113 5.18854C17.6682 6.04542 18.3219 7.0836 18.7244 8.22661H14.6734C14.4347 8.22661 14.2057 8.13177 14.0369 7.96295C13.8681 7.79412 13.7732 7.56515 13.7732 7.3264V3.27545Z",
    stroke: "#435869",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcReport);
export default __webpack_public_path__ + "static/media/ic-report.29f92eb6bd6271272e82cc8170a8c055.svg";
export { ForwardRef as ReactComponent };